module.exports = __webpack_public_path__ + "img/informe_ejecutoria.70969a78.svg";